import { Component, Injectable, OnInit} from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { AppSettings } from '../appSettings';
import { LoginService } from '../services/login.service';
import { CommonService } from '../services/common.service';
declare let swal: any;
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-becameexhangecentre',
  templateUrl: './becameexhangecentre.component.html',
  styleUrls: ['./becameexhangecentre.component.css'],
})
export class BecameExhangeCentreComponent implements OnInit {

  step = 1;
  showPassword = false;
  FetchMeSettingApiUrl: string = AppSettings.getmesettings;
  registerexchangecenterApiUrl:string = AppSettings.registerexchangecenter;
  uploadaddressfileApi:string=AppSettings.uploadaddressfile;
  mesettingmodel: any = {
    ai_dollar: 0,
    me_ai: 0,
    me_main: 0,
    me_life: 0,
    physicaloffice_ww: 0,
    lawyer_ww: 0,
    advisor_ww: 0,
    areacenter_ww: 0,
    citycenter_ww: 0,
    statecenter_ww: 0,
    countrycenter_ww: 0,
    internationalcenter_ww: 0,
    worldwidecenter_ww: 0
  };
  

  model: any = {
    user_name: '',
    selectedOption: '',
    address: '',
    addressFile: null,
    internetLifeLock: '',
    internetLifeKey: ''
  };
  data:any={};
  entered:any;
  users :any= []; //storing the data from the API
  userRestApiUrl: string = AppSettings.Userlogin; //API common URL
  currentUser:any=localStorage.getItem('currentUser');
  currentUserID:any=localStorage.getItem('currentUserID');
  currentUsername:any=localStorage.getItem('currentUser');
  currentUsergroup:any=localStorage.getItem('currentUsergroup');
  userRole:any=localStorage.getItem('userRole');
  options:any;

  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http) {

    // document.body.className="mebank-login-page";
    document.body.className="theme-red";

   }

  ngOnInit() {

    // if(localStorage.getItem('mebankLogin') == null){
    //   this.router.navigate(['./mebanklogin']);
    // }

     this.entered = 0;
     this.model.user_name=this.currentUsername;

      this.CommonService.getdata(this.FetchMeSettingApiUrl)
        .subscribe(meresultdata =>{
          // console.log("editmesetting",meresultdata.data[0]); 
          this.mesettingmodel.ai_dollar = meresultdata.data[0].ai_dollar;
          this.mesettingmodel.me_ai = meresultdata.data[0].me_ai;
          this.mesettingmodel.me_main = meresultdata.data[0].me_main;
          this.mesettingmodel.me_life = meresultdata.data[0].me_life; 
          this.mesettingmodel.id = meresultdata.data[0].id; 
          this.mesettingmodel.physicaloffice_ww = meresultdata.data[0].physicaloffice_ww;
          this.mesettingmodel.lawyer_ww = meresultdata.data[0].lawyer_ww;
          this.mesettingmodel.advisor_ww = meresultdata.data[0].advisor_ww;
          this.mesettingmodel.areacenter_ww = meresultdata.data[0].areacenter_ww;
          this.mesettingmodel.citycenter_ww = meresultdata.data[0].citycenter_ww;
          this.mesettingmodel.statecenter_ww = meresultdata.data[0].statecenter_ww;
          this.mesettingmodel.countrycenter_ww = meresultdata.data[0].countrycenter_ww;
          this.mesettingmodel.internationalcenter_ww = meresultdata.data[0].internationalcenter_ww;
          this.mesettingmodel.worldwidecenter_ww = meresultdata.data[0].worldwidecenter_ww;

          this.options = [
    { label: 'AI Internet Physical Office Worldwide', value: 'office', price: this.mesettingmodel.physicaloffice_ww, icon: 'fas fa-building' },
    { label: 'AI Internet Lawyer Worldwide', value: 'lawyer', price: this.mesettingmodel.lawyer_ww, icon: 'fas fa-gavel' },
    { label: 'AI Internet Advisor Worldwide', value: 'advisor', price: this.mesettingmodel.advisor_ww, icon: 'fas fa-user-tie' },
    { label: 'AI Internet Area Center Worldwide', value: 'area', price: this.mesettingmodel.areacenter_ww, icon: 'fas fa-map-marked-alt' },
    { label: 'AI Internet City Center Worldwide', value: 'city', price: this.mesettingmodel.citycenter_ww, icon: 'fas fa-city' },
    { label: 'AI Internet State Center Worldwide', value: 'state', price: this.mesettingmodel.statecenter_ww, icon: 'fas fa-landmark' },
    { label: 'AI Internet Country Center Worldwide', value: 'country', price: this.mesettingmodel.countrycenter_ww, icon: 'fas fa-globe' },
    { label: 'AI Internet International Center Worldwide', value: 'international', price: this.mesettingmodel.internationalcenter_ww, icon: 'fas fa-plane' },
    { label: 'AI Internet Worldwide Center', value: 'worldwide', price: this.mesettingmodel.worldwidecenter_ww, icon: 'fas fa-globe-americas' }
  ];

    });

   

      
  }

  selectOption(value: string) {
    this.model.selectedOption = value;
    // filter the options based on selected value and set the model.price
    const selectedOpt = this.options.find(opt => opt.value === value);
    if (selectedOpt){
      this.model.price = selectedOpt.price;
      this.model.ex_ce_label = selectedOpt.label;
    } 
  }

  nextStep() {
    if (this.step < 3) this.step++;
  }

  prevStep() {
    if (this.step > 1) this.step--;
  }

  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Validate file size (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        swal('Error!', 'File size must be less than 5MB', 'error');
        event.target.value = '';
        return;
      }
      
      // Validate file type
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        swal('Error!', 'Please select a valid file type (PDF, JPG, PNG)', 'error');
        event.target.value = '';
        return;
      }
      
      // this.model.addressFile = file;
      const fileSelected: File = file;
          this.CommonService.uploadFile(this.uploadaddressfileApi,fileSelected)
          .subscribe( (response) => {
             if(response.status=='success')
             {
              this.model.addressFile = response.data;
             }
              else{
                swal('',"Error while on upload photo",'Oops!');
                
                //this.toastr.errorToastr(response.data, 'Oops!');
              }
           })

    }
  }

  getOptionLabel(value: string) {
    const opt = this.options.find(o => o.value === value);
    return opt ? opt.label : '';
  }

  getOptionPrice(value: string) {
    const opt = this.options.find(o => o.value === value);
    return opt ? opt.price : 0;
  }

  getOptionIcon(value: string) {
    const opt = this.options.find(o => o.value === value);
    return opt ? opt.icon : 'fas fa-cog';
  }

  trackByValue(index: number, option: any): string {
    return option.value;
  }

  confirmPayment() {
    // Show loading state
    swal({
      title: 'Processing Payment...',
      text: 'Please wait while we process your request',
      icon: 'info',
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false
    });
    console.log("model--->",this.model);
    setTimeout(() => {
      swal({
        title: 'Confirm Payment',
        text: `You selected "${this.getOptionLabel(this.model.selectedOption)}" for $${this.getOptionPrice(this.model.selectedOption)}. Proceed?`,
        icon: 'warning',
        buttons: ['Cancel', 'Yes, Confirm'],
        dangerMode: true
      }).then((willPay) => {
        if (willPay) {
          // swal('Info!', 'Coming soon', 'success');
          
          this.CommonService.insertdata(this.registerexchangecenterApiUrl,this.model)
          .subscribe( (response) => {
            if(response.status==1)
            {
              swal('Success!', response.message, 'success');
            }else{
              swal('Error!', response.message, 'error');
            }
          });
          
          // Reset form after successful submission
          setTimeout(() => {
            this.resetForm();
            this.router.navigate(['./mebankdashboard']);
          }, 2000);
        }
      });
    }, 1000);
  }

  resetForm() {
    this.step = 1;
    this.model = {
      user_name: this.currentUsername,
      selectedOption: '',
      address: '',
      addressFile: null,
      internetLifeLock: '',
      internetLifeKey: ''
    };
    this.showPassword = false;
  }

  public loadScript(url) {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  


}
